import { render, staticRenderFns } from "./ChatroomSenderList.vue?vue&type=template&id=7922f2ac&"
import script from "./ChatroomSenderList.vue?vue&type=script&lang=js&"
export * from "./ChatroomSenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports